<template>
  <b-col :class="{ 'text-muted': !useExamResult }" class="mb-4">
    <b-row class="my-1 ">
      <b-col sm="7" class="py-1 pl-5">
        <b-form-checkbox
          v-model="useExamResult"
          :value="true"
          :unchecked-value="false"
        >
          {{ item.lectureName }}
        </b-form-checkbox>
      </b-col>
      <b-col v-if="useExamResult" sm="2">
        <b-form-input
          v-model="examResultValue"
          type="text"
          size="sm"
          min="0"
          max="100"
          class="text-uppercase"
          :state="validateExamResultValue"
          @change="update"
        />
        <b-form-invalid-feedback id="input-examResultValue-live-feedback">
          <span v-if="examResultType === 'examResultPercent'"
            >กรุณาระบุ 0-100</span
          >
          <span v-else-if="examResultType === 'examResultGrade'"
            >กรุณาระบุ A-F</span
          >
        </b-form-invalid-feedback>
      </b-col>
      <b-col v-if="useExamResult" sm="3">
        <span>% ของคะแนนข้อสอบ </span>
      </b-col>
    </b-row>
    <!-- add column and section here -->
    <template v-if="hasSectionCriteria">
      <b-row class="my-4" style="padding-left: 4.5rem;">
        Section
      </b-row>
      <b-row class="my-3" v-for="(section, index) in examInfo.sections" :key="index">
        <b-col sm="7" class="py-1" style="padding-left: 4.5rem;">
          {{ section.title }}
        </b-col>
        <b-col v-if="useExamResult" sm="2">
          <b-form-input
            v-model="section.criteria[1].lowerBoundRange"
            type="text"
            size="sm"
            min="0"
            max="100"
            class="text-uppercase"
            :state="validateSectionCriteria(section)"
            @change="updateSectionCriteria(section, index)"
          />
          <b-form-invalid-feedback :id="`input-section-${section.id}-live-feedback`">
            <span>กรุณาระบุ 0-100</span>
          </b-form-invalid-feedback>
        </b-col>
        <b-col v-if="useExamResult" sm="3">
          <span>% ของ section </span>
        </b-col>
      </b-row>
    </template>
  </b-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ExamRuleItem',
  props: {
    item: {
      type: Object,
      default: null,
    },
    isInitializing: {
      type: Boolean,
      default: true,
    },
    isExamRuleEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      courseId: this.$route.params.courseId,
      token: localStorage.getItem("token"),
      examRuleOptions: [
        { text: '% ของคะแนนข้อสอบ', value: 'examResultPercent' },
        { text: 'เกรดของข้อสอบ', value: 'examResultGrade' },
      ],
      isUseExamRule: false,
      tempExamResultType: 'examResultPercent',
      tempExamResultValue: 60,
      examInfo: null,
      hasSectionCriteria: false,
    };
  },
  async mounted() {
    await this.fetchExamById(this.item.quizExamId);
    this.examInfo = this.examInfoData;
    this.hasSectionCriteria = this.examInfo?._options?.sectionCriteria || false;

    setTimeout(() => {
    if (this.item.examRule) {
      this.isUseExamRule = true;
      if (this.item.examRule.examResultGrade) {
      //   this.tempExamResultType = 'examResultGrade';
        this.tempExamResultValue = this.item.examRule['examResultGrade'];
      } else if (this.item.examRule.examResultPercent) {
      //   this.tempExamResultType = 'examResultPercent';
        this.tempExamResultValue = this.item.examRule['examResultPercent'];
      }
    }}, 500);
  },
  computed: {
    ...mapGetters("Company", [
      "examInfoPending",
      "examInfoData"
    ]),
    examResultType: {
      get() {
        return this.tempExamResultType;
      },
      set(value) {
        this.tempExamResultType = value;
        this.tempExamResultValue =
          this.tempExamResultType === 'examResultPercent' ? 60 : 'C';
      },
    },

    examResultValue: {
      get() {
        return this.tempExamResultValue;
      },
      set(value) {
        this.tempExamResultValue =
          this.tempExamResultType === 'examResultGrade'
            ? value.toUpperCase()
            : value;
      },
    },

    validateExamResultValue() {
      if (!this.tempExamResultValue) return null;

      if (this.tempExamResultType === 'examResultPercent')
        return this.tempExamResultValue >= 0 && this.tempExamResultValue <= 100
          ? null
          : false;
      else if (this.tempExamResultType === 'examResultGrade') {
        const re = new RegExp('[A-F]$');
        return re.test(this.tempExamResultValue) ? null : false;
      }

      return null;
    },

    useExamResult: {
      get() {
        return this.isExamRuleEnabled ? this.isUseExamRule : false;
      },
      set(value) {
        this.isUseExamRule = value;

        if (value === false) {
          this.tempExamResultType = 'examResultPercent';
          this.tempExamResultValue = 60;
        }

        this.update();
      },
    },
  },
  methods: {
    ...mapActions('CourseCompleteRule', ['updateCourseExamRules']),
    ...mapActions('CourseManagement', ['getCourseInfo']),
    ...mapActions("Company", ["fetchExamById"]),
    ...mapActions("ExamBuilder", ["updateExamSectionCriteria"]),
    validateSectionCriteria(section) {
      const value = section.criteria[1].lowerBoundRange;
      if (!value && value !== 0) return null;
      
      const numValue = Number(value);
      return numValue >= 0 && numValue <= 100 ? null : false;
    },
    async updateSectionCriteria(section, index) {
      if (this.validateSectionCriteria(section) === null) {

        let criteria = [
          {
            grade: "F",
            index: 1,
            lowerBoundRange: 0,
            upperBoundRange: section.criteria[1].lowerBoundRange - 1
          },
          {
            grade: "P",
            index: 2,
            lowerBoundRange: section.criteria[1].lowerBoundRange,
            upperBoundRange: 100
          },
        ];
        
        section.criteria = criteria;

        this.$set(this.examInfo.sections[index], 'criteria', criteria)

        let sectionRequest = {
          body: { sections: this.examInfo.sections },
          id: this.examInfo.id,
          token: this.token,
        };

        this.updateExamSectionCriteria(sectionRequest);

      }
    },
    async update() {
      if (this.isInitializing) return;
      if (this.examResultValue && this.validateExamResultValue === null) {
        await this.updateCourseExamRules({
          examId: this.item.quizExamId,
          [this.tempExamResultType]: this.tempExamResultValue,
          courseId: this.courseId,
          isUseExamRule: this.isUseExamRule,
          examRule: {
            examId: this.item.quizExamId,
            [this.tempExamResultType]: this.tempExamResultValue,
          },
        });
        await this.$emit("updateRules");
      }
    },
  },
};
</script>
